// Todo change this according to hultafors group style-guide
export const fontWeights = {
  fontBold: 900,
  fontMedium: 500,
  fontRegular: 300,
} as const;
